import { DateTime } from 'luxon'

export class Rules {
  static required(value) {
    return (value !== null && value !== undefined && String(value).trim() !== '') || 'Required.'
  }

  static requiredWithMessage(message, value) {
    return (value !== null && value !== undefined && String(value).trim() !== '') || message || 'Required.'
  }

  //  String validation
  static maxLength(limit, value) {
    return !value || value.length <= limit || `${value.length - limit} characters over maximum length of ${limit}.`
  }

  static minLength(limit, value) {
    return !value || value.length >= limit || `${limit - value.length} characters under minimal length of ${limit}.`
  }

  static length(limit, value) {
    return !value || value.length === limit || `Please enter a string with a length of ${limit}.`
  }

  //  Number validation
  static isInteger(value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return value === undefined || Number.isInteger(Number(value)) || 'Please enter an integer.'
  }

  static isNumeric(value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return (
      value === undefined || value === null || String(value).trim() === '' || !isNaN(value) || 'Please enter a number.'
    )
  }

  static numberInRange(min, max, value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return (
      value === null ||
      value === undefined ||
      String(value).trim() === '' ||
      isNaN(value) ||
      (value >= min && value <= max) ||
      `Please enter a number between ${min} and ${max}.`
    )
  }

  static minNumber(min, value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return (
      value === null ||
      value === undefined ||
      String(value).trim() === '' ||
      isNaN(value) ||
      value >= min ||
      `Please enter a number greater than or equal to ${min}.`
    )
  }

  static isNegative(value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return value === null || value === undefined || isNaN(value) || value <= 0 || 'Please enter a negative number.'
  }

  static isPositive(value) {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '')
    }
    return value === null || value === undefined || isNaN(value) || value >= 0 || 'Please enter a positive number.'
  }

  //  Misc
  static validIdentifier(value) {
    return (
      !/[^a-zA-Z0-9_-]+/.test(value) ||
      'Please enter a valid identifier. Characters "A-Z", "0-9", "_", and "-" are allowed.'
    )
  }

  static validEmail(value) {
    return !value || /.+@.+/.test(value) || 'Please enter a valid e-mail address.'
  }

  static dateAfter(start, valueFormat, message, value) {
    return (
      !value ||
      !start ||
      DateTime.fromFormat(value, valueFormat, { zone: 'utc' }).set({ hour: 0, minute: 0, second: 0, milliseconds: 0 }) >
        DateTime.fromISO(start, { zone: 'utc' }).set({ hour: 0, minute: 0, second: 0, milliseconds: 0 }) ||
      message ||
      'Please choose a later date.'
    )
  }

  static isUnique({ conflictValue, conflictMessage }, message, value) {
    return (
      !value ||
      !conflictValue ||
      value !== conflictValue ||
      conflictMessage ||
      message ||
      'Please enter a unique value.'
    )
  }
}

export default { Rules }
